// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5491b2ce","355":"d844c44e","453":"64aababc","732":"a38800b4","977":"49234da2"}[chunkId] + ".chunk.js";
};